export const comments_3750238 = {"data":{"data":[],"links":{}}}